fx.ns("desktop.book.edition", class CreatingAlbum extends fx.Component{
    
	constructor()
	{
		super();
		this.destroyOnSwitch = true;
		if (fx.get("mode") == "created-ia")
			this.effect = "vslidein";
		else
		{
			this.showEffect = "hslideout";
			this.hideEffect = "hslidein";
		}
	}

	create()
	{
		/*let hContainer = new fx.components.Box();
		this.backButton = new fx.components.IconButton( {icon: fx.get("assets").arrowBack} );
		let text = new fx.components.Text({text : fx.text("Revenir"), className : "backText"});
		hContainer.addChild(this.backButton, {width:40, height:40, left : 0, top : 0})
		hContainer.addChild(text, {width: 100, height : 20, top : 10, left : 40})
		this.addChild( hContainer, {top : 15, left : 15, width:150, height:40});*/

		let box = new fx.components.Box();

		let circlesBox = new fx.components.Box("Person");

		this.personImage1 = new fx.components.Image({data : fx.get("assets").splashPhoto, className : "image"});
        this.personImage2 = new fx.components.Image({data : fx.get("assets").splashPhoto, className : "image"});
        
		this.processBar = new fx.components.RadialProgress({thickness: 10, color : "#a2d7eb", backgroundColor : "#fff", style:""});

		circlesBox.addChild(this.processBar, {width:240, height : 240, top : 10, left : "center"});
		circlesBox.addChild(this.personImage1);
        circlesBox.addChild(this.personImage2);

		box.addChild(circlesBox, {width:260, height : 260, top : 0, left : "center"});

		this.title = new fx.components.Text({text : fx.text("Je créé votre album, ca sera rapide !"), className : "title center"});
		
		box.addChild(this.title, {width:"100%", height : 40, top : 280, left : "center"});
		
		this.iconCheck = new fx.components.Image({data: fx.get("assets").checkedIcon, className : "finished"});
		box.addChild(this.iconCheck, {width:60, height : 60, top : 330, left : "center"});
		//this.iconCheck.visibleAtStart = false;
		this.iconCheck.effect = "scale";

		this.addChild(box, { width : 500, height : 350, top : "center", left : "center"});

	}

	onReady()
	{
		this.repeat(this._updateProgress, 250);

		this.on("ready", this.bookReady, this.data.creator);
		
		this.data.creator.placePhotos();
	}

	_updateProgress()
	{
		if (!this._progress || this._progress == 100)
			this._progress = 0;

		if (this._progress < 100)
			this._progress+=10;
		
		this.processBar.progress = this._progress;
	}

	bookReady()
	{
		this._progress = 100;
		this.iconCheck.show();
		this.title.text = fx.text("Votre album est prêt !");

		this.data.event("next-step", null, 2500);
	}

});

	